var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFileError = function SvgDownloadFileError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6CCCB",
    fillRule: "evenodd",
    d: "m26.285 10.287-8.002-8.002H8.113a2.4 2.4 0 0 0-2.4 2.4v22.629a2.4 2.4 0 0 0 2.4 2.4h15.772a2.4 2.4 0 0 0 2.4-2.4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E77975",
    d: "M18.283 10.285v-8l8 8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E77975",
    fillRule: "evenodd",
    d: "M16 14a.9.9 0 0 0-.9.9v4.5a.9.9 0 0 0 1.8 0v-4.5a.9.9 0 0 0-.9-.9m0 7.2a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8",
    clipRule: "evenodd"
  })));
};
export default SvgDownloadFileError;